// extracted by mini-css-extract-plugin
export default {"logo":"Menu_logo__BkFGN","brand":"Menu_brand__xqIt3"};